// src/domains/table.keys.ts —— 模板键归属（TD-823，agent-keys 用例按片 owner 推导核对）
export const KEYS = [
  'cols', 'doPrimary', 'exportCsv', 'facets', 'hasLastReq', 'hasStats', 'lastReq', 'loading', 'nextPage', 'nextStyle', 'noLastReq', 'onPageSize',
  'onQd', 'pageSize', 'pages', 'prevPage', 'prevStyle', 'primaryAction', 'qd', 'resetQuery', 'rowCountText', 'rows', 'rowsEmpty', 'runQuery',
  'searching', 'stats', 'tableBodyStyle', 'tabs', 'tipBar', 'hasTipBar',
] as const;
export const MODAL_KEYS = ['actions', 'fields', 'hasList', 'isDetail', 'list', 'listEmpty', 'listTitle'] as const;
